var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "transition-list" },
    [
      _c(
        "transition-group",
        {
          attrs: { css: false, mode: "out-in" },
          on: {
            "after-enter": _vm.tilesResize,
            "before-enter": _vm.beforeEnter,
          },
        },
        [
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showLeftIf,
                  expression: "showLeftIf",
                },
              ],
              key: "left",
            },
            [_vm._t("left")],
            2
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showRightIf,
                  expression: "showRightIf",
                },
              ],
              key: "right",
            },
            [_vm._t("right")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }